/* External Imports */
import { CheckIcon } from '@chakra-ui/icons';
import { Box } from '@chakra-ui/react';
import parser from 'html-react-parser';

/* Internal Imports */
/* Components */
import { useRouter } from 'next/router';
/* Services */

/**
 * Renders the Json Table data content component
 * @param {Object} sectionContent - Data for section
 * @returns {ReactElement} Json Table data content component
 */

function myFunction() {
  let stickyTitle = document.getElementById('stickyTitleSection');
  let proDet = document.getElementById('proDet');
  let stickyStart = document.getElementById('stickyContainer');
  if (stickyStart && proDet && proDet.offsetTop) {
    let sticky = proDet?.offsetTop - 180;
    let stickyWrapper = document.getElementById('stickyWrapper');
    if (
      window.pageYOffset < sticky &&
      window.pageYOffset > stickyStart?.offsetTop
    ) {
      stickyWrapper?.classList.add('sticky-on');
      stickyWrapper?.classList.remove('sticky-off');
      stickyTitle?.classList.add('sticky');
    } else {
      stickyWrapper?.classList.remove('sticky-on');
      stickyWrapper?.classList.add('sticky-off');
      stickyTitle?.classList.remove('sticky');
    }
  }
}

if (typeof window !== 'undefined') {
  window.addEventListener('scroll', myFunction);
}

const JsonTableData = (sectionContent, region, lang) => {
  const moduleData = sectionContent.sectionContent;
  const router = useRouter();
  const currentUrl = router.asPath.includes('/bhairavi-utsav');
  return (
    <Box
      w="100%"
      p={{
        base: '10px 0 5px 0',
        sm: '10px 0 5px 0',
        md: '30px 0 45px 0',
        lg: '30px 0 45px 0',
      }}
      textAlign={'center'}
    >
      <Box width="100%" id="stickyContainer">
        <Box
          id="stickyWrapper"
          width={{ base: '95%', sm: '95%', md: '1140px', lg: '1140px' }}
          m="0 auto"
        >
          <Box
            display={{ base: 'block', lg: 'none' }}
            id="stickyTitleSection"
            bgColor="#ffffff"
            zIndex="1"
            w={{ base: '100%', sm: '100%' }}
            left={{ base: 'unset', sm: '9%' }}
            pr="15px"
          >
            <>
              <Box
                display="flex"
                fontFamily="FedraSansStd-book"
                padding="15px"
                fontSize={{ base: '18px' }}
                _first={{
                  padding: '15px 0 0 0px',
                }}
                _last={{
                  borderBottom: 'none',
                }}
              >
                {/* <Box
                  width="1%"
                  fontSize="18px"
                  color="#818181"
                  textAlign="left"
                ></Box> */}
                <Box
                  as="div"
                  background="#EEE2C3"
                  p="10px 0px"
                  display="flex"
                  width="100%"
                  borderTopLeftRadius="15px"
                  borderTopRightRadius="15px"
                >
                  <Box
                    width="33%"
                    className="column_label"
                    borderRight="1px solid #BAAC88"
                  >
                    {parser(moduleData?.data[0]?.Category1 || '')}
                  </Box>
                  <Box
                    width="33%"
                    className="column_label"
                    borderRight="1px solid #BAAC88"
                  >
                    {parser(moduleData?.data[0]?.Category2 || '')}
                  </Box>
                  <Box width="33%" className="column_label">
                    {parser(moduleData?.data[0]?.Category3 || '')}
                  </Box>
                </Box>
              </Box>
            </>
          </Box>
        </Box>
        <Box
          as="div"
          width={{ base: '95%', sm: '95%', md: '1140px', lg: '1140px' }}
          m="0 auto"
          className="Prgrm_detail_container"
        >
          {moduleData?.data?.map((el, index) => {
            return (
              <>
                <Box
                  display="flex"
                  fontFamily="FedraSansStd-book"
                  padding="15px"
                  fontSize={{ base: '18px' }}
                  _first={{
                    padding: '15px 0 0 0',
                  }}
                  _last={{
                    borderBottom: 'none',
                  }}
                  className="Prgrm_rowdetail"
                >
                  {index === 0 && (
                    <>
                      {el.Label != '' && (
                        <>
                          <Box
                            width="21%"
                            p="15px 0px"
                            fontSize="18px"
                            color="#818181"
                            textAlign="center"
                          >
                            {parser(el.Label || '')}
                          </Box>
                        </>
                      )}
                      <Box
                        as="div"
                        background="#EEE2C3"
                        p="15px 0px"
                        display="flex"
                        width="100%"
                        borderTopLeftRadius="15px"
                        borderTopRightRadius="15px"
                        className='tableheader'
                      >
                        <Box
                          width="33%"
                          className="column_label"
                          borderRight="1px solid #BAAC88"
                        >
                          {parser(el.Category1 || '')}
                        </Box>
                        <Box
                          width="33%"
                          className="column_label"
                          borderRight="1px solid #BAAC88"
                        >
                          {parser(el.Category2 || '')}
                        </Box>
                        <Box width="33%" className="column_label">
                          {parser(el.Category3 || '')}
                        </Box>
                      </Box>
                    </>
                  )}
                  {index > 0 && (
                    <>
                      {el.Label != '' && (
                        <>
                          <Box
                            width="22%"
                            fontSize="18px"
                            fontFamily="FedraSerifAStdBook"
                            color="#818181"
                            textAlign="left"
                            paddingLeft="20px"
                            mr="5%"
                          >
                            {parser(el.Label || '')}
                          </Box>
                        </>
                      )}
                      <Box
                        width="33%"
                        fontSize={{
                          base: '13px',
                          sm: '13px',
                          md: '16px',
                          lg: '16px',
                        }}
                        fontWeight={currentUrl ? 'normal' : 'bold'}
                        color="#222222"
                      >
                        {el.Category1 === 'Yes' ? (
                          <CheckIcon fontSize="16px" color="#CF4520" />
                        ) : (
                          parser(el.Category1 || '')
                        )}
                      </Box>
                      <Box
                        width="33%"
                        fontSize={{
                          base: '14px',
                          sm: '14px',
                          md: '16px',
                          lg: '16px',
                        }}
                        fontWeight={currentUrl ? 'normal' : 'bold'}
                        color="#222222"
                      >
                        {el.Category2 === 'Yes' ? (
                          <CheckIcon color="#CF4520" />
                        ) : (
                          parser(el.Category2 || '')
                        )}
                      </Box>
                      <Box
                        width="33%"
                        fontSize={{
                          base: '14px',
                          sm: '14px',
                          md: '16px',
                          lg: '16px',
                        }}
                        fontWeight={currentUrl ? 'normal' : 'bold'}
                        color="#222222"
                      >
                        {el.Category2 === 'Yes' ? (
                          <CheckIcon color="#CF4520" />
                        ) : (
                          parser(el.Category3 || '')
                        )}
                      </Box>
                    </>
                  )}
                </Box>
              </>
            );
          })}
        </Box>
      </Box>
      <Box id="proDet"></Box>
      <style global jsx>
        {`
          .program_note p {
            margin: 10px 0;
          }
          .column_label {
            font-size: 20px;
            color: #483c1b;
            padding: 10px;
            font-weight: bold;
          }
          .column_label span {
            font-size: 14px;
            color: #9b7e31;
            display: block;
            font-weight: normal;
          }
          .Prgrm_rowdetail:first-child {
            background: transparent;
          }
          .sticky-off,
          #stickyWrapper {
            display: none;
          }
          .sticky-on {
            display: block !important;
          }
          .sticky {
            position: fixed !important;
            top: 0 !important;
            height: auto !important;
          }
          .sticky li {
            display: inline-block !important;
          }
          @media (max-width: 767px) {
            .column_label span {
              display: none;
            }
            .column_label {
              font-size: 14px;
              font-weight: bold;
              padding: 10px 5px;
            }
            .tableheader {
              flex: auto !important;
            }
            .tableheader .column_label {
              text-align: center;
            }
            .Prgrm_detail_container {
              background-position: 48% 61%;
              background-size: contain;
            }
            .Prgrm_rowdetail {
              display: flex;
              flex-direction: row;
              flex-wrap: wrap;
              border-bottom: 1px solid #b9b8b8;
            }
            .Prgrm_rowdetail > div {
              flex: 1 0 33%;
              text-align: center;
              padding: 10px 0 10px 5px;
            }
            .Prgrm_rowdetail > div:first-child {
              flex: 0 1 33%;
              text-align: left;
            }
          }
        `}
      </style>
    </Box>
  );
};

export default JsonTableData;
